<template>
    <v-layout justify-center align-center>
        <v-flex xs12 md8>
            <v-sheet class="pa-3">
                <template v-if="status=='activated'">
                    <v-flex xs12 text-xs-center>
                        <h1 class="headline font-weight-light">Tu cuenta ha sido activada</h1>
                        <small>ya puedes cerrar esta ventana</small>
                    </v-flex>
                </template>
                <template v-if="status=='error'">

                    <v-flex xs12 text-xs-center>
                        <h1 class="headline font-weight-light">Ups! hay problemas...</h1>
                        <h3 class="font-weight-light">{{error}}</h3>
                    </v-flex>

                </template>
                <template v-if="status=='loading'">
                    <h1 class="headline font-weight-light">Estamos activando tu cuenta</h1>
                    <small>Un momento por favor...</small>
                </template>
                <v-slide-y-transition>
                    <v-progress-linear v-show="status=='loading'" height="2" :indeterminate="true"></v-progress-linear>
                </v-slide-y-transition>
            </v-sheet>
        </v-flex>
    </v-layout>
</template>
<script>
    import {mapMutations} from 'vuex'
    import {ApiUtils} from '@/utils/ApiUtils'
    export default{
        props: ['code'],
        mounted(){
            this.activate()
        },
        methods:{
                ...mapMutations(['showSnackBar']),
            closeWindow(){
                window.open('your current page URL', '_self', '');
                window.close();
            },
            async activate(){
                var vm = this
                vm.status = 'loading'
                const response = await ApiUtils.makePost('account/activate', {
                    code: vm.code
                })

                if(!response.ok){
                    vm.status = 'error'
                    const json = await response.json()
                    vm.error = json.message
                    return
                }

                vm.status = 'activated'
            }
        },
        data(){
            return {
                status: 'loading',
                error: ''
            }
        }
    }
</script>